import React, { useEffect, useState } from 'react';
import LiffContext from '../context/LiffContext';
import LiffService from '../../../services/LiffService';
import OrderSummaryTable from '../../../sharedComponents/OrderSummaryTable';
import CircularProgress from '@mui/material/CircularProgress';

/** LIFF-only: show amounts with exactly 2 decimal places */
const formatAmount2Decimals = (n) =>
  Number.isFinite(Number(n))
    ? Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    : '0.00';

const LiffOrderSummary = ({ orderIds = [], orderIdsByGroup = null, onBack }) => {
  const { accessToken, shopId, customer } = React.useContext(LiffContext);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [orders, setOrders] = useState([]);
  const [orderSummary, setOrderSummary] = useState(null);
  const [groups, setGroups] = useState(null);
  const [isCompanyOrder, setIsCompanyOrder] = useState(false);

  useEffect(() => {
    if (!Array.isArray(orderIds) || orderIds.length === 0) {
      setOrders([]);
      setOrderSummary(null);
      setGroups(null);
      setLoading(false);
      return;
    }
    let cancelled = false;
    setLoading(true);
    setError('');
    LiffService.getOrderSummaryByOrderIds(accessToken, shopId, orderIds, orderIdsByGroup)
      .then((data) => {
        if (cancelled) return;
        setOrders(data.orders || []);
        setOrderSummary(data.summary || null);
        setGroups(data.groups || null);
        setIsCompanyOrder(data.isCompanyOrder === true);
      })
      .catch((err) => {
        if (cancelled) return;
        const msg = err.response?.data?.message || err.message || 'โหลดไม่สำเร็จ';
        setError(msg);
        setOrders([]);
        setOrderSummary(null);
        setGroups(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, [accessToken, shopId, JSON.stringify(orderIds), JSON.stringify(orderIdsByGroup)]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 p-4 pb-8 flex items-center justify-center">
        <CircularProgress size={32} />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 p-4 pb-8">
        <div className="max-w-sm mx-auto pt-4">
          <p className="text-red-600 text-sm mb-4">{error}</p>
          {typeof onBack === 'function' && (
            <button type="button" onClick={onBack} className="text-sm text-green-600 font-medium underline hover:text-green-700">
              ← กลับ
            </button>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 p-4 pb-8">
      <div className="max-w-full mx-auto pt-4">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-base font-semibold text-gray-800">รายละเอียดแต่ละรายการ</h2>
          {typeof onBack === 'function' && (
            <button type="button" onClick={onBack} className="text-sm text-green-600 font-medium underline hover:text-green-700">
              ← กลับ
            </button>
          )}
        </div>
        <OrderSummaryTable
          smileName={customer?.smileName}
          orders={orders}
          orderSummary={orderSummary}
          groups={groups}
          createSecondOrderPaymentLink={undefined}
          isAdmin={false}
          onOpenOrderDetail={undefined}
          shopNameOverride={shopId}
          formatAmountForTotal={formatAmount2Decimals}
        />
      </div>
    </div>
  );
};

export default LiffOrderSummary;
